/**
 * 網站開發 debug 用
 *
 *
 */
const state = () => ({
    panel: true,
    sessionId: null,
});

const actions = {};

const getters = {};

const mutations = {
    /**
     * 展開網站下方 debug panel (有登入狀態的那個)
     * @param {*} state
     */
    showPanel(state) {
        state.panel = true;
    },
    /**
     * 收合網站下方 debug panel (有登入狀態的那個)
     * @param {*} state
     */
    closePanel(state) {
        state.panel = false;
    },
    /**
     * 是否顯示網站下方 debug panel 及設定 panel 上的 session id
     * @param {*} state
     */
    setSessionId(state) {
        state.sessionId = window.crypto.randomUUID();
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
